window.app.directive("ngRepeatInit", [
  "$injector",
  function($injector) {
    return {
      priority: 5000,
      compile: function() {
        return {
          pre: function(scope, element, attrs) {
            scope.$eval(attrs.ngRepeatInit);
          }
        };
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/init.js